export const format = (text, query) => {
  if (!query) return `<span>${text}</span>`
  const segments = getSegments(text, query)
  return segments
    .map(s => {
      let output = '<span'
      output += s.bold ? ' class="bold">' : '>'
      output += s.segmentText + '</span>'
      return output
    })
    .join('')
}

export const indicesOf = (text, query) => {
  let nextIndex = text.indexOf(query)
  const indices = []
  while (nextIndex !== -1) {
    indices.push(nextIndex)
    nextIndex = text.indexOf(query, nextIndex + 1)
  }
  return indices
}

export const getSegments = (text, query) => {
  const lowercaseText = text.toLowerCase()
  const lowercaseQuery = query.toLowerCase()
  const queryLength = query.length
  const indices = indicesOf(lowercaseText, lowercaseQuery)
  const result = []
  const splits = lowercaseText.split(lowercaseQuery).filter(s => s !== '')
  let nextSplitIndex = 0
  let useMatch = indices[0] === 0
  let nextIndex = 0
  while (nextIndex < text.length) {
    const nextLength = useMatch ? queryLength : splits[nextSplitIndex++].length
    const toIndex = nextIndex + nextLength
    result.push({
      segmentText: text.substring(nextIndex, toIndex),
      bold: useMatch,
    })
    nextIndex = toIndex
    useMatch = !useMatch
  }
  return result
}

export const displayProduct = (p, productId) => {
  return typeof p !== 'undefined'
    ? `${p.NameInternal} - ${p.ExternalId} (${p.ResourceName})`
    : productId
}

export const formatProduct = (product, query) => {
  let output = format(product.NameInternal, query)
  output += ' - ' + product.ExternalId
  output += '<br /><span class="resourceName">'
  output += product.ResourceName + '</span>'
  return output
}

export const displayResource = (r, resourceId) => {
  return typeof r !== 'undefined' ? `${r.Description} (${r.ExternalResourceID})` : resourceId
}

export const formatResource = (resource, query) => {
  let output = format(resource.Description, query)
  output += '<br /><span class="externalResourceId">'
  output += resource.ExternalResourceID + '</span>'
  return output
}
